import React from 'react';
import styled from "styled-components";
import Paper from "@mui/material/Paper";
import Divider from "@mui/material/Divider";
import {colors} from "../maps/colors";
import Icn from "./Icn";

const WrapperStyled = styled.div`
  display: grid;
  position: relative;
  text-align: center;
  margin-bottom: 10px;

  .stepFieldItem-children {
    .hidden {
      display: none;
    }
  }

  &:hover {
    .stepFieldItem-children {
      .hidden {
        display: block;
      }
    }
  }

  &.step {
    .color-box {
      background: ${colors.LIGHT_ORANGE};
      width: 11px;
      height: 11px;
    }
  }

  &.field {
    .color-box {
      background: ${colors.ORANGE};
      width: 10px;
      height: 10px;
    }
  }
`;

const BottomStyled = styled.div`
  text-transform: capitalize;
`;

const InfoStyled = styled.div`
  display: grid;
  grid-template-columns: auto 1fr;
  justify-self: center;
  align-items: center;
  grid-gap: 5px;
`;

const CameraItem = ({isSelected, isCustomMode, type, name, variant = "outlined", isSquare, children, style}) => {
    let padding = '10px 10px 0 10px';
    let nameFont = '22px';
    let typeFont = '22px';
    let elevation = 0;
    let backGroundColor = colors.WHITE;
    let icon = 'sensor';
    if (isCustomMode) {
        padding = 0;
        nameFont = `${style?.width / 8}px`;
        typeFont = `${style?.width / 8}px`;
    }
    if (isSelected) {
        elevation = 24;
    }

    if (type === 'step' && isCustomMode) {
        backGroundColor = colors.LIGHT_ORANGE;
    }
    if (type === 'field' && isCustomMode) {
        icon = 'field';
        backGroundColor = colors.ORANGE;
    }

    if (type == 'camera') {
        icon = 'camera';
    }

    return (
        <Paper elevation={elevation} variant={variant} square={isSquare}
               style={{marginBottom: 10, background: backGroundColor, ...style}}>
            <WrapperStyled className={type} style={{padding}}>
                <InfoStyled style={{fontSize: nameFont}}>
                    {name}
                    {!isCustomMode && (
                        <div className="color-box"/>
                    )}
                </InfoStyled>
                <Divider variant="fullWidth"/>
                <BottomStyled style={{margin: `${isCustomMode ? "0" : "4px 0 0 0"}`}}>
                    <Icn style={{fontSize: typeFont}}>{icon}</Icn>
                </BottomStyled>
                <div className="stepFieldItem-children">
                    {children}
                </div>
            </WrapperStyled>
        </Paper>
    );
};

export default CameraItem;